var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaiIcSignal1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6438 15.3571C15.1931 16.0532 16.0444 16.5 17 16.5C18.6569 16.5 20 15.1569 20 13.5V3.5C20 1.84315 18.6569 0.5 17 0.5C15.3431 0.5 14 1.84315 14 3.5V13.5C14 14.2012 14.2406 14.8463 14.6438 15.3571ZM12.3562 15.3571C12.7594 14.8463 13 14.2012 13 13.5V7.5C13 6.6115 12.6137 5.81321 12 5.26389C11.4692 4.78885 10.7684 4.5 10 4.5C8.34315 4.5 7 5.84315 7 7.5V13.5C7 14.2012 7.2406 14.8463 7.64376 15.3571C8.19314 16.0532 9.04439 16.5 10 16.5C10.9556 16.5 11.8069 16.0532 12.3562 15.3571ZM5.35624 15.3571C5.7594 14.8463 6 14.2012 6 13.5V11.5C6 10.6115 5.61375 9.81321 5 9.26389C4.46924 8.78885 3.76835 8.5 3 8.5C1.34315 8.5 0 9.84315 0 11.5V13.5C0 15.1569 1.34315 16.5 3 16.5C3.95561 16.5 4.80686 16.0532 5.35624 15.3571ZM17 2.5C16.4477 2.5 16 2.94772 16 3.5V13.5C16 14.0523 16.4477 14.5 17 14.5C17.5523 14.5 18 14.0523 18 13.5V3.5C18 2.94772 17.5523 2.5 17 2.5ZM10 6.5C9.44771 6.5 9 6.94772 9 7.5V13.5C9 14.0523 9.44771 14.5 10 14.5C10.5523 14.5 11 14.0523 11 13.5V7.5C11 6.94772 10.5523 6.5 10 6.5Z",
    fill: "#008AD2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaiIcSignal1);
export default __webpack_public_path__ + "static/media/mai-ic-signal-1.476f2c5b54c67c2eb90a231224b130c7.svg";
export { ForwardRef as ReactComponent };